import {
	useBlockProps,
	useInnerBlocksProps,
	InnerBlocks,
	InspectorControls,
	HeightControl,
} from '@wordpress/block-editor';
// eslint-disable-next-line @wordpress/no-unsafe-wp-apis
import {
	__experimentalToolsPanelItem as ToolsPanelItem,
	ResizableBox,
} from '@wordpress/components';
import { Fragment, useRef } from '@wordpress/element';
import { useSelect } from '@wordpress/data';
import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

const ResizableContainer = ( {
	clientId,
	attributes,
	setAttributes,
	className,
	toggleSelection,
	isSelected,
} ) => {
	const { width, height } = attributes;

	return (
		<ResizableBox
			as="div"
			size={ {
				height,
				width,
			} }
			showHandle={ isSelected }
			minHeight="50"
			minWidth="50"
			enable={ {
				top: false,
				right: true,
				bottom: true,
				left: false,
				topRight: false,
				bottomRight: false,
				bottomLeft: false,
				topLeft: false,
			} }
			onResizeStop={ ( event, direction, elt, delta ) => {
				setAttributes( {
					height: height + delta.height,
					width: width + delta.width,
				} );
				toggleSelection( true );
			} }
			onResizeStart={ () => {
				toggleSelection( false );
			} }
		></ResizableBox>
	);
};

export default function Edit( {
	clientId,
	attributes,
	setAttributes,
	className,
} ) {
	const { width, height } = attributes;

	const hasInnerBlocks = useSelect(
		( select ) => {
			const { getBlock } = select( 'core/block-editor' );
			const block = getBlock( clientId );
			return !! ( block && block.innerBlocks.length );
		},
		[ clientId ]
	);

	const blockProps = useBlockProps( {
		className: classnames( className, {
			'is-empty': ! hasInnerBlocks,
		} ),
		style: {
			width: ! width ? undefined : width,
			height: ! height ? undefined : height,
		},
	} );

	const { children, ...innerBlocksProps } = useInnerBlocksProps( blockProps, {
		renderAppender: hasInnerBlocks ? null : InnerBlocks.ButtonBlockAppender,
	} );

	return (
		<Fragment>
			<InspectorControls group="dimensions">
				<ToolsPanelItem
					hasValue={ () => !! width || !! height }
					label={ __( 'Size' ) }
					onDeselect={ () =>
						setAttributes( {
							width: undefined,
							height: undefined,
						} )
					}
					resetAllFilter={ () => ( {
						width: undefined,
						height: undefined,
					} ) }
					isShownByDefault={ true }
					panelId={ clientId }
				>
					<HeightControl
						label={ __( 'Width' ) }
						labelPosition="edge"
						value={ width }
						onChange={ ( val ) => {
							setAttributes( { width: val } );
						} }
					/>
				</ToolsPanelItem>
				<ToolsPanelItem
					hasValue={ () => !! width || !! height }
					label={ __( 'Size' ) }
					onDeselect={ () =>
						setAttributes( {
							width: undefined,
							height: undefined,
						} )
					}
					resetAllFilter={ () => ( {
						width: undefined,
						height: undefined,
					} ) }
					isShownByDefault={ true }
					panelId={ clientId }
				>
					<HeightControl
						label={ __( 'Height' ) }
						labelPosition="edge"
						value={ height }
						onChange={ ( val ) => {
							setAttributes( { height: val } );
						} }
					/>
				</ToolsPanelItem>
			</InspectorControls>

			<div { ...innerBlocksProps }>{ children }</div>
		</Fragment>
	);
}
